import { components, PlaceholderProps } from 'react-select'

import { SizeOptions } from '../../../../types/types'
import { AstraParagraph } from '../../../Typography/AstraParagraph/AstraParagraph'
import { SelectOption, SelectOptionGroup } from '../types'
import { typographyStyles } from '../utils/styles'

export const placeholderClassName = () => '!m-0 text-muted'

export function CustomPlaceholder<T>(props: PlaceholderProps<SelectOption<T>, false, SelectOptionGroup<T>> & { size: SizeOptions; readOnly?: boolean }) {
    const { size, children, isDisabled, readOnly } = props
    // react-select gets `isDisabled` for read-only fields too, and read-only text stays muted
    return (
        <components.Placeholder {...props}>
            <AstraParagraph
                variant={typographyStyles[size]}
                weight="regular"
                className={isDisabled && !readOnly ? 'truncate text-disabled' : 'truncate text-muted'}
            >
                {children}
            </AstraParagraph>
        </components.Placeholder>
    )
}
